/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Left_Spry_Crocodile_FetchInputs */

const fr_left_spry_crocodile_fetch = /** @type {(inputs: Left_Spry_Crocodile_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours les moins remplis`)
};

/**

* @param {Left_Spry_Crocodile_FetchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const left_spry_crocodile_fetch = /** @type {((inputs?: Left_Spry_Crocodile_FetchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Left_Spry_Crocodile_FetchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_left_spry_crocodile_fetch(inputs)
});